<template>
  <div class="repair-apply-new">
    <!-- 办理状态（查看态展示流程节点） -->
    <business-status
      v-if="statusInfor"
      :statusInfor="statusInfor"
      :flowNodes="flowNodes"
      :busHandlingId="busHandlingId"
    />
    <div class="vant-parser">
      <parser
        v-if="formConf"
        ref="parser"
        :key="key2"
        :form-conf="formConf"
        @submit="sumbitForm"
      />
    </div>
    <!-- 资料审核中 / 待补缴资料 时可取消、可修改 -->
    <div class="footer" v-if="showActionFooter">
      <div class="btns">
        <van-button plain type="info" style="margin-right: 10px" @click="showCancelReport">
          取消申请
        </van-button>
        <van-button plain type="info" @click="updateInfo">修改信息</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import { Dialog, Toast } from 'vant';
import { findParentIdsById } from '@/utils/tools.js';
import Parser from '@/components/vant-parser/Parser';
import BusinessStatus from '../components/BusinessStatus';
import getRepairApplyNewFormConf from './repairApplyNewFormConf';
import {
  addBusHandling,
  selectBusHandlingById,
  cancelReport,
  getAbodeTreeByTenantId,
} from '@/api/business';

const BIZ_CODE = 'BSBX';
const MODULE_NAME = '报事报修';

export default {
  name: 'RepairApplyNew',
  components: {
    Parser,
    BusinessStatus,
  },
  data() {
    return {
      key2: +new Date(),
      formConf: null,
      /* businessState: add-新增；see-查看；edit-修改 */
      businessState: 'add',
      busHandlingId: null,
      /* 站点树（{ name,label,value,children }） */
      abodeList: [],
      /* 选中站点编号，用于提交 */
      abodeCode: '',
      /* 办理状态信息 */
      statusInfor: null,
      /* 流程节点数组 */
      flowNodes: [],
      /* 详情/草稿数据（来自“我的办理”列表，存于 localStorage） */
      currentFormData: null,
    };
  },
  computed: {
    /* 仅在“资料审核中 / 待补缴资料”查看态下展示取消、修改按钮 */
    showActionFooter() {
      const orderState = this.currentFormData && this.currentFormData.orderState;
      return (
        this.businessState === 'see' &&
        (orderState === 'PRE_AUDITING' || orderState === 'PRE_AUDIT_FAILED')
      );
    },
  },
  mounted() {
    this.into();
  },
  methods: {
    /* 页面初始化 */
    async into() {
      const businessNews = store.getters.businessNews || {};
      this.businessState =
        this.$route.query.state || businessNews.businessState || 'add';

      if (this.businessState === 'add') {
        this.busHandlingId = null;
        this.currentFormData = null;
        localStorage.removeItem('currentFormData');
        await store.dispatch('user/setBusinessNews', {
          businessState: 'add',
          busHandlingId: '',
          bizCode: BIZ_CODE,
          moduleName: MODULE_NAME,
        });
      } else {
        this.busHandlingId =
          this.$route.query.id || businessNews.busHandlingId || null;
        this.currentFormData = this.getCurrentFormData();
      }

      document.title = MODULE_NAME;

      await this.getAbodeCode();
      this.initFormConf();

      if (this.businessState !== 'add' && this.busHandlingId) {
        this.fillFormFromCurrentFormData();
        this.selectBusHandlingById(this.busHandlingId);
      } else {
        this.fillDefaultUserInfo();
      }
    },

    /* ---------------- 站点树 ---------------- */
    async getAbodeCode() {
      const { status, resultData } = await getAbodeTreeByTenantId();
      if (status === 'complete' && resultData && resultData.length) {
        this.abodeList = this.getAbodeList([resultData[0]]);
      }
    },
    getAbodeList(list = []) {
      return list.map((item) => ({
        ...item,
        name: item.name,
        label: item.name,
        value: item.data && item.data.id ? item.data.id : item.id,
        children:
          item.children && item.children.length > 0
            ? this.getAbodeList(item.children)
            : [],
      }));
    },
    /* tree-select 选中后回传 { value }：value 为站点编号 */
    handleTreeSelectChange(event) {
      if (event && event.value !== undefined) {
        this.abodeCode = event.value;
      }
    },

    /* ---------------- 表单配置（字段对齐 openAccount.vue 的 repair） ---------------- */
    initFormConf() {
      const data = getRepairApplyNewFormConf(this.abodeList);
      if (this.businessState === 'see') {
        data.readonly = true;
      }
      this.formConf = data;
    },

    /* ---------------- 数据回填 ---------------- */
    /* 新增态默认带出办理人姓名 */
    fillDefaultUserInfo() {
      const userInfo = store.getters.userInfo || {};
      const user = userInfo.user || {};
      const name =
        user.name ||
        userInfo.nickName ||
        userInfo.realName ||
        '';
      const telephone =
        userInfo.phone ||
        user.phone ||
        '';
      this.$nextTick(() => {
        if (this.$refs.parser) {
          this.$refs.parser.fillForm({
            contacts: name,
            telephone,
            name,
          });
        }
      });
    },
    getCurrentFormData() {
      if (this.currentFormData) return this.currentFormData;
      const currentFormDataStr = localStorage.getItem('currentFormData');
      if (!currentFormDataStr) return null;
      try {
        this.currentFormData = JSON.parse(currentFormDataStr);
        return this.currentFormData;
      } catch (error) {
        return null;
      }
    },
    fillFormFromCurrentFormData() {
      const currentFormData = this.getCurrentFormData();
      if (!currentFormData || !currentFormData.orderContent) return;
      const data = this.parseDetailForm(currentFormData);
      // tree-select 回显：记录站点编号
      if (data.abodeCode) this.abodeCode = data.abodeCode;
      this.$nextTick(() => {
        if (this.$refs.parser) this.$refs.parser.fillForm(data);
      });
    },
    /* 解析订单 orderContent 为表单可回填的对象 */
    parseDetailForm(resultData = {}) {
      const content = resultData.formContent || resultData.orderContent;
      if (!content) return {};
      try {
        const form = JSON.parse(content);
        if (!Array.isArray(form)) return form;
        const data = {};
        form.forEach((item) => {
          const key = item.key || item.prop;
          if (!key) return;
          // tree-select 的 abodeName 回填为编号（vModel 存 value）
          if (key === 'abodeName') {
            data.abodeName = item.value;
          } else if (key === 'abodeCode') {
            data.abodeCode = item.value;
          } else if (key === 'images') {
            data.images = this.getUploadFormValue(item.value);
          } else {
            data[key] = item.value;
          }
        });
        return data;
      } catch (error) {
        return {};
      }
    },

    /* ---------------- 提交 ---------------- */
    /* 将表单配置 + 表单值转换为后端需要的 form 数组（参照 openAccount.vue 提交结构） */
    convertFormToTargetFormat(formConf, formData) {
      const form = [];
      const processFields = (fields) => {
        fields.forEach((field) => {
          const config = field.__config__ || {};
          if (config.layout === 'rowFormItem' && config.children) {
            processFields(config.children);
            return;
          }
          if (field.__vModel__ && config.layout === 'colFormItem') {
            const key = field.__vModel__;
            const label = config.label || '';
            let value = formData[key] !== undefined ? formData[key] : null;
            const tag = config.tag || field._tag || '';

            let type = 'input';
            if (
              tag === 'el-tree-select' ||
              tag === 'vc-tree-select' ||
              tag === 'a-tree-select'
            ) {
              type = 'tree-select';
            } else if (
              tag === 'el-upload' ||
              tag === 'a-upload' ||
              tag === 'vc-uploader'
            ) {
              type = 'upload';
              value = this.normalizeUploadValue(value);
            } else if (field.type === 'textarea') {
              type = 'textarea';
            }

            const fieldObj = { key, label, type, value, disabled: false };
            if (type === 'tree-select') {
              fieldObj.options = field.options || [];
            }
            form.push(fieldObj);

            // 站点名称后追加站点编号
            if (key === 'abodeName') {
              form.push({
                key: 'abodeCode',
                label: '站点编号',
                type: 'input',
                value: this.abodeCode,
              });
            }
          }
        });
      };

      if (formConf && formConf.fields) {
        processFields(formConf.fields);
      }
      // 站点数组（父级路径），后台用于管辖范围
      const manageSiteIds = findParentIdsById(this.abodeList, this.abodeCode);
      form.push({
        key: 'manageSiteIds',
        label: '站点数组',
        type: 'input',
        value: manageSiteIds,
        disabled: true,
      });
      return form;
    },
    /* 上传字段统一为对象数组（{ fileId, id, url }） */
    normalizeUploadValue(value) {
      if (!value) return [];
      let files = value;
      if (typeof value === 'string') {
        try {
          files = JSON.parse(value);
        } catch (error) {
          return [];
        }
      }
      if (!Array.isArray(files)) files = [files];
      return files
        .reduce((list, item) => list.concat(item), [])
        .map((item) => {
          if (item && typeof item === 'object') {
            const fileId = item.fileId || item.id || '';
            return { ...item, fileId, id: item.id || fileId };
          }
          return { fileId: item, id: item };
        })
        .filter((item) => item.fileId);
    },
    /* 回填时把上传值转为 vc-uploader 需要的 JSON 字符串 */
    getUploadFormValue(value) {
      const files = this.normalizeUploadValue(value);
      return files.length ? JSON.stringify(files) : '';
    },
    /* 表单提交 */
    sumbitForm(data) {
      const userInfo = store.getters.userInfo || {};
      const phone =
        data.telephone || userInfo.phone || '';
      const transactor =
        data.contacts || userInfo.nickName ||'';
      const idCard = userInfo.idCard || '';
      const form = this.convertFormToTargetFormat(this.formConf, data);
      const params = {
        bizCode: BIZ_CODE,
        bizHandleId: this.busHandlingId || '',
        // 报事报修无绑定水户
        clientAddress: '',
        clientCode: '',
        clientName: '',
        customerNo: '',
        abodeCode: this.abodeCode || '',
        // 登录人信息
        idCard,
        orderSource: 'wx',
        phone,
        transactor,
        userId: userInfo.userId || '',
        form,
      };
      this.addBusHandling(params);
    },
    async addBusHandling(params) {
      const { status, resultData } = await addBusHandling(params);
      if (status === 'complete') {
        this.busHandlingId = (resultData && resultData.busHandlingId) || this.busHandlingId;
        this.handerDialog(
          this.businessState === 'edit' ? '修改' : '提交',
          resultData && resultData.processingDays
        );
      }
    },
    handerDialog(dialogName, processingDays) {
      Dialog.confirm({
        title: `您的报事报修已${dialogName}成功！`,
        message:
          processingDays !== undefined && processingDays !== null
            ? `预计在${processingDays}个工作日内完成，请耐心等待，可至“我的办理”中查看办理进度。`
            : '工作人员会尽快与您联系，请耐心等待。',
        confirmButtonText: '返回首页',
        confirmButtonColor: '#3C7EF0',
        showCancelButton: false,
      }).then(() => {
        this.$router.push({ path: '/' });
      });
    },

    /* ---------------- 办理详情 / 状态 ---------------- */
    async selectBusHandlingById(id) {
      const { status, resultData } = await selectBusHandlingById(id);
      if (status === 'complete' && resultData.length) {
        this.flowNodes = resultData;
        // 最新节点
        const latestNode = this.flowNodes[this.flowNodes.length - 1];
        this.statusInfor = {
          progessName: latestNode.postBizStatus || '',
          progessStatus: this.mapStatusToCode(latestNode.postBizStatus),
          progessStatusName: latestNode.eventDesc || latestNode.auditContent || '',
          progessCreateTime: latestNode.createTime,
          progessRemark: latestNode.auditContent || '',
          processingDays: null,
          stateBoolean: false,
        };
        // 重新回填一次表单（确保详情数据展示）
        this.fillFormFromCurrentFormData();
      } else {
        this.statusInfor = null;
      }
    },
    /* 状态名称 → 状态码（与 BusinessStatus 颜色映射对应） */
    mapStatusToCode(statusName) {
      const statusMap = {
        资料审核中: 'nh_00_01_st',
        待补缴资料: 'nh_00_01_st',
        办理中: 'nh_01_00_st',
        处理中: 'nh_01_00_st',
        已办结: 'nh_03_00_st',
        已拒绝: 'nh_02_00_st',
        已作废: 'nh_02_00_st',
        已取消: 'nh_02_00_st',
      };
      return statusMap[statusName] || 'nh_00_01_st';
    },

    /* ---------------- 取消 / 修改 ---------------- */
    showCancelReport() {
      Dialog.confirm({
        message: '您确定取消申请吗？',
        confirmButtonText: '取消申请',
        confirmButtonColor: '#3C7EF0',
        cancelButtonText: '点错了',
        cancelButtonColor: '#767E8C',
      })
        .then(() => {
          this.cancelReport();
        })
        .catch(() => {});
    },
    async cancelReport() {
      const userInfo = store.getters.userInfo || {};
      const { status } = await cancelReport({
        auditBy: userInfo.userId,
        auditContent: '',
        auditor: userInfo.nickName,
        bizHandleId: this.busHandlingId,
        event: 'CANCEL_TASK',
      });
      if (status === 'complete') {
        Toast('该业务已取消');
        this.currentFormData = {
          ...(this.currentFormData || {}),
          orderState: 'CANCELLED',
        };
        localStorage.setItem('currentFormData', JSON.stringify(this.currentFormData));
        this.setBusinessState('see');
        this.key2 = +new Date();
        this.formConf = { ...this.formConf, readonly: true };
        this.selectBusHandlingById(this.busHandlingId);
      }
    },
    updateInfo() {
      this.setBusinessState('edit');
      this.key2 = +new Date();
      this.formConf = { ...this.formConf, readonly: false };
      this.$nextTick(() => {
        this.fillFormFromCurrentFormData();
      });
    },
    setBusinessState(state) {
      this.businessState = state;
      store.dispatch('user/setBusinessNews', {
        ...(store.getters.businessNews || {}),
        businessState: state,
        busHandlingId: this.busHandlingId,
        bizCode: BIZ_CODE,
        moduleName: MODULE_NAME,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.repair-apply-new {
  min-height: 100vh;
  overflow: hidden;
  background: #f7f8fa;

  .vant-parser {
    margin: 16px 16px 88px 16px;
    overflow: hidden;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    padding: 15px 0;
    background: #ffffff;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;

    .btns {
      width: 100%;
      text-align: center;
      margin: 0 16px;

      /deep/.van-button--normal {
        width: calc(100% / 2 - 10px);
        border-radius: 8px;
      }
    }
  }
}
</style>
